import type { History } from 'history';
import { makeAutoObservable } from 'mobx';
import { TModules } from '@tools/ui/types';

class ModuleStore {
  activeModule?: TModules;
  otherModules: TModules[];
  favoriteModules: TModules[];
  private readonly defaultTitle = 'Melio OS';
  private hasCustomTitle = false;

  constructor() {
    makeAutoObservable(this);
  }

  private updateTabTitle(): void {
    if (this.hasCustomTitle) return;
    document.title = this.activeModule
      ? `${this.activeModule.name} | ${this.defaultTitle}`
      : this.defaultTitle;
  }

  setCustomTabTitle(title: string): void {
    this.hasCustomTitle = true;
    const moduleName = this.activeModule?.name ?? this.defaultTitle;
    document.title = `${title} | ${moduleName}`;
  }

  resetTabTitle(): void {
    this.hasCustomTitle = false;
    this.updateTabTitle();
  }

  setDataModules(
    location: History['location'],
    allowedDataModules: Array<any>,
    favoriteModulesIds: string[] = []
  ): void {
    const otherModules = allowedDataModules.filter(
      (module) =>
        !('hideFromMenu' in module) && !favoriteModulesIds.includes(module.path)
    );
    const favoriteModules = allowedDataModules.filter(
      (module) =>
        !('hideFromMenu' in module) && favoriteModulesIds.includes(module.path)
    );
    this.activeModule = allowedDataModules.find((module) =>
      location.pathname.startsWith(module.path)
    );

    this.updateTabTitle();
    this.otherModules = otherModules;
    this.favoriteModules = favoriteModules;
  }
}

export default new ModuleStore();
